import axios from "axios";
import {useRef, useEffect, useState} from "react";
import {toast} from "react-toastify";
import Loader from "../Loader";
import "../Login/Login.scss";
import {Link, useNavigate} from "react-router-dom";
import Swal from 'sweetalert2';
import _axios from "../../httpService";

export default function ForgetPassword(props) {

    const [showPasswordSection, SetShowPasswordSection] = useState(0);
    const phoneNumber = useRef(null);
    const enteredCaptcha = useRef(null);


    const newPassword1 = useRef(null);
    const newPassword2 = useRef(null);
    const smsCodeRef = useRef(null);
    const [errorMessage, setErrorMessage] = useState("");
    const [isSmsTrue, setIsSmsTrue] = useState(true);
    const [temp, setTemp] = useState({user: "", code: ""});
    const [userPhoneNumberState, setUserPhoneNumberState] = useState("")

    const navigateTo = useNavigate();

    function phoneNumberOnChange(event) {
        if (isNaN(event.target.value)) phoneNumber.current.value = phoneNumber.current.value.replace(/\D/g, '');
    }

    function sendSMSRequest(userPhoneNumber) {
        axios({
            method: "get",
            url: `${localStorage.getItem("apiUrl")}/password/?mobileNumber=` + userPhoneNumber,
        })
            .then((response) => {
                giveMeNewCaptchaCode();
                response = response.data
                // response={status:false, msg:"no userFound with this Phone Number!"};
                if (response.status === false) {
                    Swal.fire({
                        icon: 'error',
                        title: response.message,
                        showCancelButton: false,
                        cancelButtonText: "لغو",
                        confirmButtonText: "تلاش مجدد"
                    })
                } else if (response.status) {
                    toast.success("پیامک ارسال شد.");
                    SetShowPasswordSection(1);
                }
            })
            .catch((error) => {
                error.response.status === 401 &&
                setErrorMessage("نام کاربری یا رمز عبور نادرست است");
            });
    }

    function sendSmsToResetPassword(event) {

        event.preventDefault();
        //check Number
        const userPhoneNumber = phoneNumber.current.value;
        if (userPhoneNumber.length !== 11) {
            toast.error("در وارد کردن شماره موبایل دقت کنید.")
            return;
        }
        //captcha Check
        if (!check(enteredCaptcha.current.value)) {
            toast.error("در وارد کردن کپچا دقت کنید.")
            return;
        }

        setUserPhoneNumberState(userPhoneNumber);
        sendSMSRequest(userPhoneNumber)
    }


    let alphabets = "AaBbCcDdEeFfGgHhIiJjKkLlMmNnOoPpQqRrSsTtUuVvWwXxYyZz";
    const generate = () => {
        let first = alphabets[Math.floor(Math.random() * alphabets.length)];
        let second = Math.floor(Math.random() * 10);
        let third = Math.floor(Math.random() * 10);
        let fourth = alphabets[Math.floor(Math.random() * alphabets.length)];
        let fifth = alphabets[Math.floor(Math.random() * alphabets.length)];
        let sixth = Math.floor(Math.random() * 10);
        let captcha =
            first.toString() +
            second.toString() +
            third.toString() +
            fourth.toString() +
            fifth.toString() +
            sixth.toString();
        return captcha;
    };
    const check = (value) => {
        return value.toLowerCase() === chaptchaCode.toLowerCase();
    };
    const [chaptchaCode, setChaptchaCode] = useState(generate());
    const giveMeNewCaptchaCode = () => {
        setChaptchaCode(generate());
    };

    function smsCodeInpuOnChangetHandler() {
        const enteredSms = smsCodeRef.current.value;
        if (enteredSms.length === 5) {
            // اینجا باید درخواست بزنم به بک
            axios({
                method: "post",
                url: `${localStorage.getItem("apiUrl")}/password/`,
                params: {code: enteredSms}
            }).then((response) => {
                response = response.data
                if (response.status) {
                    setTemp({"user": response.user, "code": response.code})
                    setIsSmsTrue(false);
                    setErrorMessage("");
                } else {
                    setErrorMessage(response.message);
                    setIsSmsTrue(true);
                }

            });

        } else {
            setErrorMessage("کد پیامکی 5 رقم می باشد");
            setIsSmsTrue(true);
        }

    }

    function sendRequestToChangePassword(event) {
        event.preventDefault();

        if (newPassword1.current.value !== newPassword1.current.value) {
            toast.error("تکرار رمز عبور صحیح نیست.")
        } else {
            let obj = {type: "recovery", user: temp.user, code: temp.code, password: newPassword1.current.value}
            // _axios.put("", "").then(response => {
            // });

            axios({
                method: "put",
                url: `${localStorage.getItem("apiUrl")}/password/`,
                data: obj
            })
                .then((response) => {
                    response = response.data
                    if (response.status) {
                        Swal.fire({
                            icon: 'success',
                            title: response.message,
                            showCancelButton: false,
                            confirmButtonText: "رفتن به صفحه ورود",
                            allowOutsideClick:false
                        }).then((result) => {
                            /* Read more about isConfirmed, isDenied below */
                            if (result.isConfirmed) {
                                navigateTo("/Login");
                            }
                        })

                    } else {
                        setErrorMessage(response.message);
                    }

                });
        }


    }

    return (
        <div className="login-page py-4 mt-1  mb-5">
            <div className="container">
                <div className="wrapper login-section ">
                    <div className="title">
                        <span>فراموشی رمز</span>
                    </div>
                    <form>
                        {showPasswordSection === 0 ?
                            <>
                                <div className="row">
                                    <i className="fas fa-user"></i>
                                    <input ref={phoneNumber}
                                           name="phoneNumber"
                                           placeholder={
                                               "شماره تماس خود را وارد کنید"
                                           }
                                           type="text"
                                           dir={"ltr"}
                                           className={"text-center"}
                                           onChange={phoneNumberOnChange}
                                           novalidate
                                    />
                                </div>
                                <div className="row">
                                    <i className="fa" onClick={giveMeNewCaptchaCode}>
                                        &#xf021;
                                    </i>
                                    <div
                                        className=" disable-selection font-for-capcha input-style"
                                        id="generated-captcha"
                                    >
                                        {chaptchaCode}
                                    </div>
                                </div>
                                <div className="row">
                                    <i className="fas fa-lock"></i>
                                    <input
                                        ref={enteredCaptcha}
                                        className="entered-captcha default_Font"
                                        type="text"
                                        name="entered-captcha"
                                        placeholder="کد بالا را وارد کنید"
                                        aria-autocomplete="both" aria-haspopup="false" autoCapitalize="off"
                                        autoComplete="off"
                                        autoCorrect="off" autoFocus="" role="combobox" spellCheck="false"
                                    />
                                </div>
                                <p className="error-field">{errorMessage}</p>
                                <div className="row button mt-4">
                                    <input type={"submit"} onClick={sendSmsToResetPassword} value="ارسال پیامک "/>
                                </div>
                            </>
                            :
                            <>
                                <>
                                    <div className="row">
                                        <i className="fas fa-user"></i>
                                        <input ref={smsCodeRef}
                                               name="phoneNumber"
                                               placeholder={"کد پیامک شده را وارد کنید"}
                                               type="text"
                                               dir={"ltr"}
                                               className={"text-center"}
                                               onChange={smsCodeInpuOnChangetHandler}
                                               novalidate
                                        />
                                    </div>
                                    {/*<span onClick={()=>sendSMSRequest(userPhoneNumberState)}> ارسال مجدد رمز عبور</span>*/}
                                    <div className="row">
                                        <i className="fas fa-lock"></i>
                                        <input
                                            ref={newPassword1}
                                            className="entered-captcha default_Font"
                                            type="text"
                                            name="entered-captcha"
                                            placeholder="رمز جدید "

                                            aria-autocomplete="both" aria-haspopup="false" autoCapitalize="off"
                                            autoComplete="off"
                                            autoCorrect="off" autoFocus="" role="combobox" spellCheck="false"
                                        />
                                    </div>
                                    <div className="row">
                                        <i className="fas fa-lock"></i>
                                        <input
                                            ref={newPassword2}
                                            className="entered-captcha default_Font"
                                            type="text"
                                            name="entered-captcha"
                                            placeholder="تکرار رمز جدید"

                                            aria-autocomplete="both" aria-haspopup="false" autoCapitalize="off"
                                            autoComplete="off"
                                            autoCorrect="off" autoFocus="" role="combobox" spellCheck="false"
                                        />
                                    </div>

                                    <p className="error-field">{errorMessage}</p>
                                    <div className="row button mt-4">
                                        <input
                                            className={isSmsTrue ? "opacity50" : "opacity100"}
                                            type={"submit"}
                                            onClick={sendRequestToChangePassword}
                                            value="تغییر رمز عبور" disabled={isSmsTrue}/>

                                    </div>
                                </>
                            </>
                        }
                    </form>
                    <div className="pass">
                        <span><Link to={"/Login"}>بازگشت به صفحه ورود</Link></span></div>
                </div>
            </div>
        </div>
    );
}
